import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=506ec14c&scoped=true"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"
import style0 from "./CommentList.vue?vue&type=style&index=0&id=506ec14c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ec14c",
  null
  
)

export default component.exports